import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import { cloneDeep } from "lodash"

export default (context) => {

  context.saveGrade = function (item) {
    this.props.setLoader(true);
    // console.log(this.state.form)
    let body = {
      grades: [
        {
          averaged: "0",
          conceptId: item.conceptId,
          gradeTxt: this.state.form[item.concept].toUpperCase(),
          studentId: this.state.idItemSelected,
        }
      ]
    }
    // console.log(body)
    _axios
      .post('admGrades/master', body)
      .then(r => {
        this.props.setLoader(false)
        if (r && r.msg) NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      }).catch((e) => {
        console.log(e)
        this.props.setLoader(false)
      })
  }

  context.openSubGrid = function (ctx) {
    context.props.setLoader(true);
    _axios
      .get("/admGrades/getByStudent/" + context.state.idItemSelected + "?periodId=0&isBehavior=true&periodId=" + this.state.formFilter.periodId)
      .then(r => {
        if (r.status >= 0) {
          // console.log(this.view.form.subforms[0].fields)
          if (r.data && r.data.Results) {
            this.all = null
            const qualifications = r.data.Results[0].qualifications
            const qualificationsList = qualifications.split(',').map(e => e = {value: e, label: e})

            r.data.Results.forEach(e => {
              this["grade_" + e.conceptId] = e.gradeTxt
            })
            let updateAverage = (ctxForm) => {
              _axios
                .get('admGrades/group?studentId=' + this.state.idItemSelected + '&isBehavior=true')
                .then(r => {
                  if (r && r.status >= 0) {
                    ctxForm.setState({average: r.data.find(e => e.concept === 'CPROM').gradeTxt})
                  }
                }).catch((e) => {
                  console.log(e)
                })
            }

            let temp = []
            temp.push(
              {
                col: 12,
                name: "Actualizar",
                value: "Actualizar todas las notas",
                type: "label"
              },
              {
                col: 6,
                name: "all",
                value: "",
                type: "select",
                label: "Nota",
                opts: {
                  style: 'float-label',
                  items: qualificationsList
                },
                onChange: (ctx) => {
                  ctx.setState({btnSaveAll: this['all'] !== ctx.state['all']})
                }
              },
              {
                col: 6,
                name: "btnSaveAll",
                type: "button",
                label: "Guardar",
                onClick: (ctx) => {
                  context.props.setLoader(true);
                  let body = {
                    grades: []
                  }
                  // console.log(ctx)
                  ctx.props.fields.forEach(e => {
                    if (e.name.indexOf("grade") > -1) {
                      ctx.setState({[e.name]: ctx.state.all})
                      context[e.name] = ctx.state.all
                      body.grades.push(
                        {
                          averaged: "0",
                          conceptId: e.name.split('_')[1],
                          gradeTxt: ctx.state.all,
                          studentId: context.state.idItemSelected
                        }
                      )
                    }
                  })
                  _axios
                    .post('admGrades/master', body)
                    .then(r => {
                      context.props.setLoader(false)
                      if (r && r.status >= 0) {
                        ctx.setState({btnSaveAll: false})
                        context.all = ctx.state.all
                        updateAverage(ctx)
                      }
                      if (r && r.msg) NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                    }).catch((e) => {
                      context.props.setLoader(false);
                    })
                },
                classNameF: (ctx) => {
                  return ctx.state.btnSaveAll && ctx.state.all ? '' : 'd-none'
                },
              },
              {
                col: 12,
                name: "hr",
                value: "<hr class='mb-5'></hr>",
                type: "label"
              },
              {
                col: 6,
                name: "average",
                value: ctx.state.CPROM,
                type: "text",
                label: "Consejo de Promoción",
                disabled: true
              },
              {
                col: 6,
                name: "space",
                value: "",
                type: "label"
              }
            )

            r.data.Results.forEach((e, i) => {
              // console.log(e.gradeTxt, e.l0)
              if (e.l0) {
                temp.push(
                  /*
                  {
                    col: 6,
                    name: "grade_" + e.conceptId,
                    value: e.gradeTxt,
                    type: "text",
                    label: e.l0,
                    opts: {
                      style: 'float-label'
                    },
                    maxLength: "2"
                  },
                  */
                  {
                    col: 6,
                    name: "grade_" + e.conceptId,
                    value: e.gradeTxt,
                    type: "select",
                    label: e.l0,
                    opts: {
                      style: 'float-label',
                      items: qualificationsList
                    },
                    onChange: (ctx) => {
                      ctx.setState({['btn_' + e.conceptId]: this['grade_' + e.conceptId] !== ctx.state['grade_' + e.conceptId]})
                    }
                  },
                  {
                    col: 6,
                    name: "btn_" + e.conceptId,
                    type: "button",
                    label: "Modificar",
                    value: false,
                    onClick: (ctx) => {
                      context.props.setLoader(true);
                      const body = {
                        grades: [
                          {
                            averaged: "0",
                            conceptId: e.conceptId,
                            gradeTxt: ctx.state["grade_" + e.conceptId],
                            studentId: context.state.idItemSelected
                          }
                        ]
                      }
                      _axios
                        .post('admGrades/master', body)
                        .then(r => {
                          context.props.setLoader(false);
                          if (r && r.status >= 0) {
                            ctx.setState({['btn_' + e.conceptId]: false})
                            context["grade_" + e.conceptId] = ctx.state['grade_' + e.conceptId]
                            updateAverage(ctx)
                          }
                          if (r && r.msg) NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                        }).catch((e) => {
                          context.props.setLoader(false);
                        })
                    },
                    classNameF: (ctx) => {
                      return ctx.state['btn_' + e.conceptId] && ctx.state["grade_" + e.conceptId] ? '' : 'd-none'
                    },
                  }
                )
              }
            });

            this.view.form.subforms[0].fields = temp
            this.view.form.subforms[0].listenToogleSubform = (open) => {
              if (!open) this.getGrades(true)
            }
            // console.log(temp)
            // process.nextTick(() => { ctx.setState({ formFields: temp }) })
          }

          ctx.toogleSubForm(0)
        } else NotificationManager.error(r.msg, "Error", 5000, null, null, 'outline')
        context.props.setLoader(false)
      }).catch((e) => {
        context.props.setLoader(false);
        console.log(e)
      })
  }

  context.getGrades = function (update) {
    _axios
      .get('admGrades/group?studentId=' + this.state.idItemSelected + '&isBehavior=true&periodId=' + this.state.formFilter.periodId)
      .then(r => {
        if (r.status >= 0) {
          const temp = cloneDeep(this.state.formFields)
          r.data.map(e => e.gradeTxt = e.gradeTxt ? e.gradeTxt.toUpperCase() : "")

          if (update) {
            temp.map((f) => {
              if (f.type === 'text') {
                let item = r.data.find(e => e.concept === f.name)
                if (item) f.value = item.gradeTxt
              }
              return f
            })
          } else {
            temp.push(
              {
                col: 12,
                type: "label",
                name: "Conducta",
                value: r.data.length === 0 ? "No hay notas de conducta ingresadas" : "<h2>Comportamiento<h2>"
              }
            )
            r.data.forEach(e => {
              temp.push(
                {
                  col: 4,
                  name: e.concept,
                  label: e.concept === "CPROM" ? "CONSEJO DE PROMOCION" : e.name,
                  type: "text",
                  value: e.gradeTxt,
                  opts: {
                    style: 'float-label'
                  },
                  onChange: (ctx) => {
                    ctx.setState({['btn_' + e.concept]: true})
                  },
                  maxLength: "2",
                  disabled: ["CONDF", "TUTR"].indexOf(e.concept) > -1 ? false : true
                },
                /*
                {
                  col: 4,
                  name: e.concept,
                  label: e.name,
                  type: "select",
                  value: e.gradeTxt,
                  opts: {
                    style: 'float-label',
                    items: [
                      { value: "AD", label: "AD" },
                      { value: "A", label: "A" },
                      { value: "B", label: "B" },
                      { value: "C", label: "C" },
                      { value: "D", label: "D" }
                    ]
                  },
                  onChange: (ctx) => {
                    console.log(ctx)
                    ctx.setState({['btn_' + e.concept]: true})
                  },
                },
                */
                {
                  col: 8,
                  name: 'btn_' + e.concept,
                  type: "button",
                  label: "Modificar",
                  value: e.concept === "CPROM" ? true : false,
                  onClick: (ctx) => {
                    if (["CONDF", "TUTR"].indexOf(e.concept) > -1) this.saveGrade(e)
                    else if (e.concept === "CPROM") this.openSubGrid(ctx)
                  },
                  classNameF: (ctx) => {
                    return e.concept === 'CPROM' || (ctx.state['btn_' + e.concept] && ctx.state[e.concept]) ? '' : 'd-none'
                  },
                  disabled: ["CPROM", "CONDF", "TUTR"].indexOf(e.concept) > -1 ? false : true
                }
              )
            });
          }

          this.setState({formFields: temp})
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      }).catch((e) => { console.log(e) })
  }

  context.getMyTeachers = function () {
    _axios
      .get('me/teachers?userId=' + this.state.idItemSelected)
      .then(r => {
        if (r.status >= 0) {
          // console.log(this.state.formFields)
          const sectionOwner = r.data.find(e => e.role === 'section-owner')
          const superSectionOwner = r.data.find(e => e.role === 'supersection-owner')
          const temp = cloneDeep(this.state.formFields)
          temp.map(e => {
            if (e.name === 'sectionOwner') e.value = sectionOwner ? (sectionOwner.name + ' ' + sectionOwner.last) : ''
            if (e.name === 'superSectionOwner') e.value = superSectionOwner ? (superSectionOwner.name + ' ' + superSectionOwner.last) : ''
            return e
          })
          this.setState({formFields: temp}, () => {
            this.getGrades()
          })
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      }).catch((e) => { console.log(e) })
  }

  return {

    config: {
      resource: "admStudent",
      pageSize: 40,
      list: false,
      hideBtnSave:true,
      remapRow: (form) => {
        return form
      }
    },

    actions: {
      create: false,
      edit: true,
      delete: false,
      print: false,
      export: false,
      search: true
    },

    filter: {
      fields: [
        {
          name: "periodId",
          value: { value: "0", label: "Actual" },
          type: "select",
          label: "Periodo",
          opts: {
            style: 'float-label',
            path: "/admPeriod/get?pick=true"
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "Grado",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "Sección",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        },
        {
          name: "userId",
          value: "",
          type: "select",
          label: "Alumno",
          rules: 'required',
          parent: "sectionId",
          opts: {
            style: 'float-label',
            searchOnline: true,
            withImg: true,
            path: () => { return "/admStudent/get?pick=true&sectionId=" + context.state.formFilter.sectionId }
          }
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return ctx.state.periodId || ctx.state.superSectionId || ctx.state.userId },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          process.nextTick(() => { context.getMyTeachers() })
        }
        return r
      },
      setValuesBeforePost: (v) => {
        delete v.flags
        return v
      },
      fields: [
        {
          col: 12,
          name: "faceUrl",
          value: null,
          type: "image",
          label: "Foto",
          opts: {
            backgroundImage: require("../../assets/img/user.png")
          }
        },
        {
          col: 6,
          name: "superSectionName",
          value: "",
          type: "text",
          label: "Grado",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 6,
          name: "sectionName",
          value: "",
          type: "text",
          label: "Sección",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: "Alumno",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        /*
        {
          col: 12,
          name: "trimestre",
          value: "",
          type: "text",
          label: "Trimestre",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        */
        {
          col: 12,
          name: "sectionOwner",
          value: "",
          type: "text",
          label: "Tutor",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
        {
          col: 12,
          name: "superSectionOwner",
          value: "",
          type: "text",
          label: "Asesor de promoción",
          opts: {
            style: 'float-label'
          },
          disabled: true
        },
      ],
      subforms: [
        {
          name: 'Registrar notas', 
          fields: []
        }
      ]
    },

    columns: [
      {
        Header: "ID",
        accessor: "ID"
      },
      {
        Header: "Alumno",
        accessor: "name"
      },
      {
        Header: "Grado",
        accessor: "sectionTag"
      }
    ]
  }
}